/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { quickViewModalLoad } from '../../../analytics';

export default (set, get) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  quickViewModalLoad();
}), false, { type: 'TRACK_QUICK_VIEW_MODAL_CLICK' });
